<template>
  <div>
    <div v-if="campList.length > 0">
      <div class="col-12 col-lg-9">
        <div class="row list-wrap">
          <div
            class="col-12 col-lg-6"
            v-for="(ins, i) in campListByInstitute"
            :key="i"
          >
            <div class="list-title text-center old-small-bold">
              <!-- <div>{{ item.nation }}</div> -->
              <div>{{ i }}</div>
            </div>
            <template v-if="ins.length > 0">
              <div
                :class="
                  'list-row mt-3 mt-lg-0 d-flex flex-column flex-lg-row ' +
                  'justify-content-between text-center'
                "
                v-for="data in ins"
                :key="data.name"
              >
                <div
                  :class="
                    'student old-small col ' +
                    'd-flex justify-content-center justify-content-lg-around'
                  "
                >
                  <template v-if="data.name != null">
                    <div class="name text-center col-4">{{ data.name }}</div>
                    <div class="school text-center col-8">
                      {{ data.school }}
                    </div>
                  </template>
                  <div v-else class="text-center">從缺</div>
                </div>
              </div>
            </template>
            <div v-else class="col-lg-9 text-center pt-1">尚未公布</div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="col-lg-9 text-center mb-5 h4-style">
      ～名單尚未公布～
    </div>
    <!-- <div class="note">
      <div class="old-small-bold mb-2">複審會議審查決議</div>
      <div class="old-mini">
        <div class="mb-2">
          {{
            "一、依據簡章規定，以總成績排序(p32)，參考學員志願表與專業技能調查表，" +
            "逐次分發語言成績合格學員至各校。"
          }}
        </div>
        <div class="mb-2">
          {{
            "二、海外培訓單位Supinfocom、Gobelins、Polygon要求3D動畫專長學生，" +
            "故以學員專業技能調查表學員自填「3D動畫」欄位「熟練」以上者才予以分發。其他單位不予設限。"
          }}
        </div>
        <div class="mb-2">
          {{ "三、上述決議與合格名單經由複審委員會決議通過並公告。" }}
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { getOverseasList } from '@/api/camp-list';

export default {
  name: 'CampCourses',
  components: {
  },
  data() {
    return {
      campList: [],
    };
  },
  computed: {
    campListByInstitute() {
      return this.groupBy(this.campList, 'institute');
    },
  },
  methods: {
    groupBy(xs, key) {
      return xs.reduce((rv, x) => {
        // eslint-disable-next-line no-param-reassign
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    getList() {
      const filter = { where: { group: parseInt(this.$route.params.groupId[5], 10), stage: 3 }, order: 'phase asc, sort asc' };
      getOverseasList({ filter }).then((response) => {
        this.campList = response;
      });
    },
  },
  created() {
    this.getList();
  },
  watch: {
    '$route.params.groupId': function () {
      if (Object.prototype.hasOwnProperty.call(this.$route.params, 'groupId')) this.getList();
    },
  },
};
</script>
<style lang="stylus" scoped>
.list-wrap
  > div
    margin-bottom: 80px;

.list-title
  padding-bottom: 8px;
  border-bottom: 1px solid $monoc4;

.list-row
  padding: 4px;

  + .list-title
    margin-top: 80px;

.name
  min-width: 100px;
</style>
